import { AiOutlineHeart, AiOutlineShoppingCart } from 'react-icons/ai'
import { FiUser } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { addToCart } from '../helper/services/cart'
const Header = () => {
  return (
    <div className={`fixed top-0 left-0 right-0 z-50 py-2`} style={style}>
      <div className="relative flex flex-row items-center justify-between px-16 overflow-hidden bg-transparent">
        <div className="flex flex-row items-center">
          <div>
            <Link to={'/'}>
              <img
                src="https://www.munchies.com.bd/_next/image?url=%2Fimages%2Flogo.png&w=256&q=75"
                alt="munchies logo"
                className="h-12"
              />
            </Link>
          </div>
          <div>
            {/* <input
              type="text"
              className="h-10
    form-control
    block
    w-full
    px-3
    py-1.5
    text-base
    font-normal
    text-gray-700
    bg-transparent bg-clip-padding
    border border-solid border-cyan-500 rounded-md shadow-sm focus:outline-none focus:shadow-outline
    
  "
              id="exampleFormControlInput1"
              placeholder="What are you looking for?"
            /> */}
          </div>
        </div>
        {/* this is 2nd icons list */}
        <div className="flex flex-row items-center space-x-5 text-gray-50">
          <div>
            <Link to={'/checkout'}>
              <AiOutlineShoppingCart
                style={{
                  color: '#fff',
                }}
              />
              {/* {addToCart.get().length} */}
            </Link>
          </div>

          <div>
            <FiUser
              style={{
                color: '#fff',
              }}
            />
          </div>
          <div>
            <AiOutlineHeart
              style={{
                color: '#fff',
              }}
            />
          </div>
          <a
            href="https://play.google.com/store/apps/details?id=com.now.munchies.app&hl=en&gl=US"
            target="_blank"
            rel="noreferrer"
          >
            <button className="p-1 text-white bg-cyan-500 rounded-xl">
              Download App
            </button>
          </a>
        </div>
      </div>
    </div>
  )
}
const style = {
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  backdropFilter: 'blur(8px)',
}

export default Header
